import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Study() {
  const { user } = useAuth();
  if (user?.track === "colleges") return <Navigate to="/dashboard/colleges" replace />;
  if (user?.track === "universities") return <Navigate to="/dashboard/courses" replace />;
  return <Navigate to="/dashboard/track" replace />;
}
